import { Component, ChangeDetectionStrategy, Input, ViewChild, signal } from '@angular/core';
import { StockInfo } from '@pedix-workspace/shared-stock';

import { TranslocoDirective } from '@ngneat/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
  selector: 'pxw-stock-errors-dialog',
  templateUrl: './stock-errors-dialog.component.html',
  styleUrls: ['./stock-errors-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent],
})
export class StockErrorsDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  stockErrors = signal<StockInfo[]>([]);

  open(stockErrors: StockInfo[]) {
    this.stockErrors.set(stockErrors);

    return this.modalDialog.open().catch(() => {});
  }
}
